import { render, staticRenderFns } from "./Prob2.vue?vue&type=template&id=711a1580&scoped=true&"
import script from "./Prob2.vue?vue&type=script&lang=js&"
export * from "./Prob2.vue?vue&type=script&lang=js&"
import style0 from "./Prob2.vue?vue&type=style&index=0&id=711a1580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711a1580",
  null
  
)

export default component.exports